import { render, staticRenderFns } from "./derivatives.vue?vue&type=template&id=b71409d0&scoped=true"
import script from "./derivatives.vue?vue&type=script&lang=js"
export * from "./derivatives.vue?vue&type=script&lang=js"
import style0 from "./derivatives.vue?vue&type=style&index=0&id=b71409d0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71409d0",
  null
  
)

/* custom blocks */
import block0 from "./locale/derivatives-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Fderivatives.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/derivatives-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Fderivatives.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default,IconCard: require('/vercel/path0/components/IconCard.vue').default,Decorator: require('/vercel/path0/components/ui/decorator.vue').default,FeaturesGridTwo: require('/vercel/path0/components/FeaturesGridTwo.vue').default,StartTradingSteps: require('/vercel/path0/components/StartTradingSteps.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,PhoneNumber: require('/vercel/path0/components/micro/PhoneNumber.vue').default,EmailAddress: require('/vercel/path0/components/micro/EmailAddress.vue').default,WebAddress: require('/vercel/path0/components/micro/WebAddress.vue').default,VideoList: require('/vercel/path0/components/blocks/VideoList.vue').default,FaqsAccordion: require('/vercel/path0/components/datablocks/FaqsAccordion.vue').default,FloatingModal: require('/vercel/path0/components/FloatingModal.vue').default})
